module.exports = __webpack_public_path__ + "static/media/multisim.138bae4e.svg";